export default __webpack_public_path__ + "static/media/other-income.39e7c435.svg";